var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplaneIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paperplane_illustration",
    xmlns: "http://www.w3.org/2000/svg",
    width: 492.97,
    height: 379.844,
    viewBox: "0 0 492.97 379.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ee2b47;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #73111f;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #ff5a60;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M994,558l57,119,1-95,282-284Z",
    transform: "translate(-842 -297.156)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1124,623l-74-43v97Z",
    transform: "translate(-842 -297.156)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1212,677l-162-96,270-271-88.76,70.073L997,565,842,531l472.73-224.474L1314,307l5.12-2.56,10.62-5.042,5.24-2.246Z",
    transform: "translate(-842 -297.156)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplaneIllustration);
export default __webpack_public_path__ + "static/media/paperplane_illustration.58473f874e8ab78517dbfe3e60287df1.svg";
export { ForwardRef as ReactComponent };